import { faClock, faPlus } from '@fortawesome/pro-solid-svg-icons';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { LiveRadar } from '@sorare/core/src/atoms/icons/LiveRadar';
import { SwitchIcon } from '@sorare/core/src/atoms/icons/SwitchIcon';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

type Props = {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
};

export const LiveGamesFilter = ({ checked, onChange, disabled }: Props) => {
  return (
    <Button
      color="tertiary"
      size="small"
      onClick={onChange}
      disableDebounce
      disabled={disabled}
    >
      <Horizontal gap={0.5}>
        <LiveRadar size={2} color="var(--c-red-400)" />
        <FontAwesomeIcon icon={faPlus} size="2xs" color="var(--c-white)" />
        <FontAwesomeIcon icon={faClock} size="xs" color="var(--c-nd-600)" />
        <SwitchIcon size="small" checked={checked} />
      </Horizontal>
    </Button>
  );
};
